import { Injectable } from '@angular/core';
import { BaseSiteService } from '@spartacus/core';
import { EnvironmentService } from './environment.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(
    private baseSiteService: BaseSiteService,
    private environmentService: EnvironmentService
  ) {}

  public siteKey: string | null = null;

  async loadConfig() {
    await this.baseSiteService
      .getActive()
      .pipe(take(1))
      .toPromise()
      .then((active) => {
        if (active) {
          this.siteKey = this.environmentService.getCurrentEnvironment().reCaptchaV3.siteKey[active];
        }
      });
  }
}
